import CryptoJS from 'crypto-js';

// IMPORTANT: This key must match the backend DB_ENCRYPTION_KEY
// This is a SECURITY RISK - the key will be visible in the frontend code
// For production, set REACT_APP_ENCRYPTION_KEY in your .env file
const ENCRYPTION_KEY = process.env.REACT_APP_ENCRYPTION_KEY || 'change-this-encryption-key-32chars';

/**
 * Check if a string is already encrypted
 * Encrypted strings are base64 and typically longer than 20 characters
 */
function isEncrypted(data) {
    if (typeof data !== 'string' || data.length < 20) {
        return false;
    }
    // Encrypted data is base64 format
    const base64Pattern = /^[A-Za-z0-9+/=]+$/;
    return base64Pattern.test(data);
}

/**
 * Decrypt a single field
 */
export function decryptField(encryptedData) {
    if (!encryptedData || encryptedData === '') {
        return encryptedData;
    }

    // If not encrypted, return as-is (for backward compatibility)
    if (!isEncrypted(encryptedData)) {
        return encryptedData;
    }

    try {
        const bytes = CryptoJS.AES.decrypt(encryptedData, ENCRYPTION_KEY);
        const decrypted = bytes.toString(CryptoJS.enc.Utf8);
        
        // If decryption resulted in empty string, data might be corrupted
        if (!decrypted) {
            console.warn('Decryption resulted in empty string, returning original');
            return encryptedData;
        }
        
        // Try to parse as JSON, return string if it fails
        try {
            return JSON.parse(decrypted);
        } catch {
            return decrypted;
        }
    } catch (error) {
        console.error('Field decryption error:', error);
        // Return original if decryption fails (for backward compatibility)
        return encryptedData;
    }
}

/**
 * Decrypt multiple fields in an object
 */
export function decryptFields(obj, fieldsToDecrypt) {
    if (!obj || typeof obj !== 'object') {
        return obj;
    }
    
    const decrypted = { ...obj };
    
    fieldsToDecrypt.forEach(field => {
        if (decrypted[field] !== undefined && decrypted[field] !== null) {
            decrypted[field] = decryptField(decrypted[field]);
        }
    });
    
    return decrypted;
}

/**
 * Decrypt all student fields that are typically encrypted
 */
export function decryptStudentFields(student) {
    const fieldsToDecrypt = [
        'mothercontact', 'motheremail', 'motherresidence',
        'fathercontact', 'fatheremail', 'fatherresidence',
        'guardiancontact', 'guardianemail', 'guardianresidence',
        'residence'
    ];
    
    return decryptFields(student, fieldsToDecrypt);
}

/**
 * Decrypt an array of students
 */
export function decryptStudents(students) {
    if (!Array.isArray(students)) {
        return students;
    }
    
    return students.map(student => decryptStudentFields(student));
}
